import { render, staticRenderFns } from "./LinkBase.vue?vue&type=template&id=55013645&scoped=true&lang=pug"
import script from "./LinkBase.vue?vue&type=script&lang=ts"
export * from "./LinkBase.vue?vue&type=script&lang=ts"
import style0 from "./LinkBase.vue?vue&type=style&index=0&id=55013645&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55013645",
  null
  
)

export default component.exports